import { render } from "./edit-client-managing-partner.vue?vue&type=template&id=7a140df2"
import script from "./edit-client-managing-partner.vue?vue&type=script&lang=js"
export * from "./edit-client-managing-partner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__